import { http } from '../shared/api';

export const searchActionPlans = (filters, config) => http.post(
  '/api/climate-action/action-plans/search',
  filters,
  config,
);

export const createActionPlan = (body) => http.post(
  '/api/climate-action/action-plans',
  body,
);

export const getActionPlan = (planId, config) => http.get(
  `/api/climate-action/action-plans/${planId}`,
  config,
);

export const updateActionPlan = (planId, body) => http.put(
  `/api/climate-action/action-plans/${planId}`,
  body,
);

export const upsertActionPlanEstimate = (planId, fiscalYear, body) => http.put(
  `/api/climate-action/action-plans/${planId}/estimates/${fiscalYear}`,
  body,
);

export const deleteActionPlan = (planId) => http.delete(
  `/api/climate-action/action-plans/${planId}`,
);

export const bulkUpdateActionPlanStatus = (body) => http.post(
  '/api/climate-action/action-plans/bulk-status',
  body,
);

export const estimateActionPlanPreview = (body) => http.post(
  '/api/climate-action/action-plans/estimate-preview',
  body,
);

export const listActionPlanResults = (planId, config) => http.get(
  `/api/climate-action/action-plans/${planId}/results`,
  config,
);

export const getActionPlanResult = (planId, fiscalYear, config) => http.get(
  `/api/climate-action/action-plans/${planId}/results/${fiscalYear}`,
  config,
);

export const getActionPlanResultInputOptions = (planId, fiscalYear, config) => http.get(
  `/api/climate-action/action-plans/${planId}/results/${fiscalYear}/input-options`,
  config,
);

export const upsertActionPlanResult = (planId, fiscalYear, body) => http.put(
  `/api/climate-action/action-plans/${planId}/results/${fiscalYear}`,
  body,
);

export const verifyActionPlanResult = (resultId, body = {}) => http.post(
  `/api/climate-action/action-plans/results/${resultId}/verify`, body,
);

export const rejectActionPlanResult = (resultId, body = {}) => http.post(
  `/api/climate-action/action-plans/results/${resultId}/reject`, body,
);

export const uploadActionPlanEvidence = (resultId, files) => {
  const formData = new FormData();
  (Array.isArray(files) ? files : [files]).forEach(file => formData.append('files', file));
  return http.upload(`/api/climate-action/action-plans/results/${resultId}/evidence`, formData);
};

export const downloadActionPlanEvidence = evidenceId => http.get(
  `/api/climate-action/action-plans/results/evidence/${evidenceId}/download`,
  { responseType: 'blob' },
);

export const deleteActionPlanEvidence = evidenceId => http.delete(
  `/api/climate-action/action-plans/results/evidence/${evidenceId}`,
);
